import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

/** Small "Sync camera" checkbox shared by the map and 3D viewer. */
export default function ViewSyncToggle({ syncCamera, setSyncCamera, className = '', style }) {
  const { C } = useTheme();
  return (
    <label
      className={`flex items-center gap-1.5 px-2 py-1 rounded-md text-[11px] cursor-pointer ${className}`}
      style={{ background: C.pillBg, color: C.pillText, border: `1px solid ${C.border}`, ...style }}
      title="Keep the map centre and the 3D camera target in step"
    >
      <input type="checkbox" checked={!!syncCamera} onChange={(e) => setSyncCamera(e.target.checked)} className="accent-pink-400" />
      Sync camera
    </label>
  );
}
